var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94444 2.94444C8.54557 2.94444 8.22222 2.62109 8.22222 2.22222C8.22222 1.82335 8.54557 1.5 8.94444 1.5H13.2778C13.6767 1.5 14 1.82335 14 2.22222V6.55556C14 6.95443 13.6767 7.27778 13.2778 7.27778C12.8789 7.27778 12.5556 6.95443 12.5556 6.55556V3.96582L3.46582 13.0556H6.05556C6.45443 13.0556 6.77778 13.3789 6.77778 13.7778C6.77778 14.1767 6.45443 14.5 6.05556 14.5H1.72222C1.32335 14.5 1 14.1767 1 13.7778V9.44444C1 9.04557 1.32335 8.72222 1.72222 8.72222C2.12109 8.72222 2.44444 9.04557 2.44444 9.44444V12.0342L11.5342 2.94444H8.94444Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandSidebarIcon);
export default __webpack_public_path__ + "static/media/expand-sidebar-icon.68cf9e85e78bfad72d5d8ae43e1c3712.svg";
export { ForwardRef as ReactComponent };